module.exports = __webpack_public_path__ + "img/Multiview - Pink - Selected.46c8224d.png";